import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function ReservationPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="bg-auto bg-repeat" style={{ backgroundImage: 'url(https://storage.helloreaddy.io/project_files/fbab44cd-04c6-492b-a442-ed8f359ae362/72c694f9-1409-463b-96d1-bc011dfd125d_compressed_14.webp)' }}>
        {/* Page Header */}
        <section className="pt-28 pb-12 md:pt-36 md:pb-16 px-4 md:px-6 bg-secondary-50">
          <div className="max-w-4xl mx-auto text-center">
            <p className="font-heading text-xs md:text-sm tracking-[0.3em] text-accent-600 mb-4">
              {t('reservation_label')}
            </p>
            <h1 className="font-heading text-2xl md:text-3xl tracking-wider text-foreground-900 mb-4">
              {t('reservation_title')}
            </h1>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-xl mx-auto whitespace-pre-line">
              {t('reservation_subtitle')}
            </p>
          </div>
        </section>

        {/* Phone Reservation */}
        <ScrollReveal as="section" className="py-20 md:py-28 px-4 md:px-6 bg-transparent">
          <div className="max-w-md mx-auto text-center">
            <div className="bg-secondary-50 rounded-lg p-10 md:p-12 border border-secondary-200/60">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <i className="ri-phone-line text-4xl text-accent-600" />
              </div>
              <h2 className="font-heading text-lg tracking-wider text-foreground-900 mb-6 reveal-child">
                {t('reservation_phone_title')}
              </h2>
              <p className="font-heading text-3xl tracking-wider text-foreground-800 mb-4 reveal-child reveal-delay-1">
                {t('reservation_phone')}
              </p>
              <p className="text-xs text-foreground-500 leading-relaxed reveal-child reveal-delay-1">
                {t('reservation_phone_note')}
              </p>

              <div className="mt-8 pt-6 border-t border-secondary-200/40">
                <p className="text-sm text-foreground-500 leading-relaxed reveal-child reveal-delay-2">
                  {t('reservation_note')}
                </p>
                <div className="flex flex-wrap justify-center gap-2 mt-4 text-xs text-foreground-400 reveal-child reveal-delay-3">
                  <span className="bg-background-50 px-3 py-1.5 rounded-full border border-secondary-200/60 whitespace-nowrap">{t('reservation_tag_date')}</span>
                  <span className="bg-background-50 px-3 py-1.5 rounded-full border border-secondary-200/60 whitespace-nowrap">{t('reservation_tag_people')}</span>
                  <span className="bg-background-50 px-3 py-1.5 rounded-full border border-secondary-200/60 whitespace-nowrap">{t('reservation_tag_allergy')}</span>
                </div>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </main>
      <Footer />
    </div>
  );
}